<template>
  <div v-if="value && value.length" class="trusted">
    <slot :value="value">
      <v-runtime-template :template="withMedia" />
    </slot>
  </div>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template';

export default {
  name: 'Attr',
  props: ['value'],
  components: {
    VRuntimeTemplate,
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.value) {
        const $parent = this.$el.parentElement || this.$el.parentNode;
        const textContent = $parent.textContent.replace(/\s+/, '');

        if (textContent.length === 0) {
          $parent.style.display = 'none';
        } else {
          $parent.style.display = 'block';
        }
      }
    });
  },
  computed: {
    withMedia() {
      return `<p>${this.value.replace(/media=/gi, 'v-media media=')}</p>`;
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$nextTick(() => {
          if (!this.value) {
            const $parent = this.$el.parentElement || this.$el.parentNode;
            const textContent = $parent.textContent.replace(/\s+/, '');

            if (textContent.length === 0) {
              $parent.style.display = 'none';
            } else {
              $parent.style.display = 'block';
            }
          }
        });
      }
    },
  },
};
</script>
